import { useState, useEffect, useRef } from 'react';
import { io, Socket } from 'socket.io-client';
import { useAuth } from '../context/AuthContext';

export interface Message {
    room: string;
    authorName: string;
    authorId: string;
    message: string;
    timestamp: string;
}

export const useChat = (roomName: string) => {
    const { user } = useAuth();
    const [messages, setMessages] = useState<Message[]>([]);
    const socketRef = useRef<Socket | null>(null);

    useEffect(() => {
        if (!user) return;

        const newSocket = io("http://localhost:5000", {
            withCredentials: true 
        });
        socketRef.current = newSocket;

        newSocket.emit('join_room', roomName);

        newSocket.on('receive_message', (message: Message) => {
            setMessages((prevMessages) => [...prevMessages, message]);
        });

        return () => {
            newSocket.disconnect();
        };
    }, [roomName, user]);

    // ✅ FIX: This function now updates the local state optimistically
    const sendMessage = (message: string) => {
        if (socketRef.current && message && user) {
            const messagePayload = {
                room: roomName,
                message,
            };
            socketRef.current.emit('send_message', messagePayload);
            
            // Add the message to our own list immediately
            const optimisticMessage: Message = {
                ...messagePayload,
                authorId: user._id,
                authorName: user.name,
                timestamp: new Date().toISOString()
            };
            setMessages((prevMessages) => [...prevMessages, optimisticMessage]);
        }
    };

    return { messages, sendMessage, currentUser: user };
};